
export const FormatMoney = (num, style = 'currency', currency = 'USD') => {
  return num.toLocaleString('us-US', { style, currency });  
}

export const FormatPercent = (num) => {
  return num.toLocaleString(undefined, {style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export const FormatVariance = (dollarDif, classification) => {

  let actual = 0
  console.log('calss', classification)
  if(classification == 'Revenue') {
    actual = dollarDif * -1;
  } else {
    actual = dollarDif;
  }

  if (actual < 0) {
    return (
      <span className="inline-flex items-center rounded-md bg-red-100 px-2 py-1 text-xs font-medium text-red-700">
        {FormatMoney(actual)}
      </span>
    )
  }

  return `${FormatMoney(actual)}`
}

export const FormatTransactionData = (jsonData) => {
  if (!jsonData || !jsonData.Columns || !jsonData.Rows) {
    throw new Error("Invalid JSON structure. Expected Columns and Rows.");
  }

  const columns = jsonData.Columns.Column.map(col => col.ColTitle);

  return jsonData.Rows.Row.map(row => {
    const formattedRow = {};
    row.ColData.forEach((colData, index) => {
      const key = columns[index].toLowerCase().split(/[^a-z0-9]/gi).map((word, idx) => idx === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)).join('');
      let value = colData.value;

      // Check if the column is 'transaction-type' to include the ID as uuid
      if (key === "transactionType") {
        formattedRow[key] = value
        formattedRow['transactionId'] = colData.id;
      } else {
        // Convert amount to number
        if (key === "amount") {
          value = parseFloat(value) || 0;
        }
        formattedRow[key] = value;
      }
    });
    return formattedRow;
  });
}